import { __decorate } from "tslib";
import $ from 'jquery';
import SwiperCore, { Navigation } from 'swiper/core';
import Swiper from 'swiper';
import { throttle } from 'helpful-decorators';
import { Breakpoint } from '../types/breakpoint';
import { getCurrentBreakpoint } from '../utils/breakpoint';
import ContentSameSize from '../core/components/content-same-size';
export default class GiftsSlider {
    static swiper;
    static $slider = $('.js__gifts-slider');
    static $sliderContainer = $('.js__gifts-slider-container');
    static options = {
        slidesPerView: 2,
        resizeObserver: true,
        spaceBetween: 10,
        breakpoints: {
            [Breakpoint.lg]: {
                slidesPerView: 4,
                spaceBetween: 20,
                centeredSlides: false,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    };
    static init() {
        if (!this.$slider.length) {
            return;
        }
        const slidesCount = this.$slider.find('.js__swiper-slide').length;
        if (slidesCount < 4) {
            //@ts-ignore
            this.options.breakpoints[Breakpoint.lg].slidesPerView = slidesCount;
        }
        SwiperCore.use([Navigation]);
        const sliderOffsetPadding = this.calculateSliderPadding();
        this.swiper = new Swiper(this.$slider.get(0), {
            ...this.options,
            slidesOffsetBefore: sliderOffsetPadding,
            slidesOffsetAfter: sliderOffsetPadding,
        });
        $(window).on('resize', this.handleResize.bind(this));
        ContentSameSize.setContentHeight();
    }
    static calculateSliderPadding() {
        return (this.$sliderContainer.outerWidth(true) - this.$sliderContainer.width()) / 2;
    }
    static handleResize() {
        const currentBreakpoint = getCurrentBreakpoint();
        if (currentBreakpoint < Breakpoint.lg) {
            const sliderOffsetPadding = this.calculateSliderPadding();
            this.swiper.params.slidesOffsetBefore = sliderOffsetPadding;
            this.swiper.params.slidesOffsetAfter = sliderOffsetPadding;
            this.swiper.update();
        }
    }
}
__decorate([
    throttle(300)
], GiftsSlider, "handleResize", null);
